<template>
  <div class="footer-section">
    <colofon-social />
    <p class="text bold"> {{ content.accountability.title }} </p>
    <p class="text"> {{ content.accountability.text1 }} </p>
    <p class="text"> {{ content.accountability.text2 }} </p>
    <div class="colofon">
      <p class="text bold">Redactie</p>
      <p class="text">Ardi Vleugels<br>Jurjen Ijsseldijk</p>
      <p class="text bold">Design &amp; code</p>
      <p class="text">Lars Boogaard<br>Drewes Bos<br>Mike van Boxtel<br>Ben Prins</p>
    </div>
  </div>
</template>
<script>

import { trackSection } from '../utils/track.js'
import ColofonSocial from '../components/ColofonSocial'

export default {
  components: {
    ColofonSocial
  },
  data () {
    return {
      tracked: false
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    tracking: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.checkTracker()
    })
  },
  methods: {
    checkTracker () {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true
          trackSection(this.tracking.trackingId)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer-section {
    position: relative;
    max-width: 600px;
    margin: auto auto;
    padding: 50px 30px;
    color: $nos-op3-white;
    z-index: 10;
  }
  .text {
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 28px;
  }
  .bold {
    font-weight: bold;
  }
  .colofon {
    margin-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/sections/FooterSection.vue